<template>
  <div>
    <div class="row">
      <div class="col-md-12" v-if="!notaCarregada">
        <card card-body-classes="table-full-width px-3">
          <div slot="header">
            <h4 class="card-title f-20-mobile">Entrada de Nota do dia {{data_inicio_cabecalho}} à {{data_fim_cabecalho}}</h4>
          </div>
          <div class="row">
            <input type="date" class="form-control mx-2 mx-auto-mobile my-2-mobile" style="max-width: 220px" v-model="data_inicio">
            <input type="date" class="form-control mx-2 mx-auto-mobile my-2-mobile" style="max-width: 220px" v-model="data_fim">
            <button class="btn btn btn-round btn-wd btn-info mx-auto-mobile mb-2-mobile btn-primary" style="height: 30px; margin-left: 20px; padding: 0px; margin-top: 0px;" id="filtrar" @click="filtrar"> Filtrar</button>
            <div class="form-group col-md-12" style="margin-top:25px" v-if="cadastroWeb">
              <h5 style="font-size:15px">XML</h5>
              
              <button class="btn btn-info"><input type="file" aria-describedby="fileHelp"
               @change="processFile($event)" v-text="file" id="arquivo" name="arquivo">{{(file)? file : 'Selecionar Arquivo...'}}</button>
             </div>
             <div class="form-group col-md-6">
              <button v-show="file != null" class="btn btn-info" @click="iniciar" style="margin-right: 10px"> Iniciar entrada</button>
            </div>
          </div>

          <div class="mb-3">
            <div v-for="nota of notas" class="row py-3 px-2 bordered-block-table only-mobile">
              <div class="col-6">
                <span style="color: #888; font-size: 10px;">{{ nota.dt_doc | moment("DD/MM/YYYY HH:mm") }}</span>
                <br>
                <strong>Chave {{ nota.num_doc }}</strong>
                <br>
                <strong>Fornecedor {{ nota.fornecedor_object.nome_razao }}</strong>
              </div>
              <div class="col-6">
                Vl {{ nota.vl_doc | currencyBrl(true) }}
              </div>
            </div>
          </div>
          <a :href="notasHref" target="_blank" class="btn btn btn-round btn-wd btn-info mx-auto-mobile mb-2-mobile btn-primary">Exportar PDF</a>
          <table class="display responsive nowrap table table-hover table-striped table-bordered hidden-mobile">
            <thead>
              <tr>
                <th class="">D. Emissão</th>
                <th class="text-right">Chave da NF-e</th>
                <th class="text-center">Numero documento</th>
                <th class="text-center">Fornecedor</th>
                <th class="text-center">Valor da Nota</th>
                <th class="text-center">Ações</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="nota of notas">
                <td class="">{{ nota.dt_doc | moment("DD/MM/YYYY  HH:mm") }}</td>
                <td class="">{{ nota.chv_nfe }}</td>
                <td class="">{{ nota.num_doc }}</td>
                <td class="text-center">{{ nota.fornecedor_object.razao_nome }}</td>
                <td class="text-center">{{ nota.vl_doc }}</td>
                <td class="text-center">
                  <!-- <a target="_blank" :href="link+nota.codigo+ '?token='+token" class="btn btn-primary btn-sm" title="Baixar XML" style="padding-left: 10px; margin-right: 3px; padding-right: 10px; font-size: 10px">
                    <i class="fa fa-download" style=""></i>
                  </a> -->
                  <button class="btn btn-sm btn-danger" title="Excluir entrada"  style="font-size: 10px; padding-left: 10px; padding-right: 10px" @click="excluirCadastro(nota)">
                    <i class="fa fa-close"></i>
                  </button>
                </td>
              </tr>
              <tr v-if="!notas || !notas.length">
                <td class="text-center" colspan="9">Nenhum resultado encontrado</td>
              </tr>
            </tbody>
          </table>
        </card>
      </div>
    </div>

    <entrada-component ref="entradaComponent" @onComplete="onComplete" @onCancelled="onCancelled"></entrada-component>
  </div>
</template>
<script>
  import {
    Card,
  } from 'src/components'
import moment from 'moment'
import FiscalService from '@/services/FiscalService.js'
import EntradaComponent from '@/pages/Fiscal/EntradaComponent'
import ErrorService from '@/services/ErrorService.js'

export default {
    components: {
      Card,
      EntradaComponent,
    },
    data() {
      return {
        notasHref: '',
        token:localStorage.getItem('token'),
        data_inicio: moment().format("YYYY-MM-DD"),
        data_fim: moment().format("YYYY-MM-DD"),
        data_fim_cabecalho:moment().format("DD/MM/YYYY"),
        data_inicio_cabecalho:moment().format("DD/MM/YYYY"),
        notas: [],
        notas_url: '',
        link: process.env.VUE_APP_API_URL + "notasCompra/download/",
        loja:null,
        produtos:[],
        file: null,
        base64: null,
        notaCarregada: false,
        status: 'null',
        cadastroWeb: localStorage.getItem('config_modulo_cadastro_web') == "true" ? true : false,
        moduloCategoriaFiscal: localStorage.getItem('config_modulo_categoria_fiscal') == "true" ? true : false,
      }
    },
    methods:{
      onComplete(data) {
        console.log(data)
      },
      onCancelled(data) {
        this.notaCarregada = false;
      },
      filtrar() {
        this.data_fim_cabecalho = moment(this.data_fim).format('DD/MM/YYYY');
        this.data_inicio_cabecalho = moment(this.data_inicio).format('DD/MM/YYYY');
        this.loadNotas();
      },
      excluirCadastro(obj){
        this.$swal({
          title: 'Deseja apagar essa entrada de nota?',
          text: 'Essa ação não pode ser revertida!',
          icon: 'warning',
          showCancelButton: true,
          confirmButtonText: 'Prosseguir',
          cancelButtonText: 'Cancelar',
          reverseButtons: true
        }).then(result => {
          if(result.value){
            FiscalService.deletaPorId({codigo:obj.codigo}).then(ret => {
              this.$swal({
                text: 'Entrada removida !',
                type: 'success'
              }).then(() => {
                this.loadNotas();
              });
            });
          }
        })
      },
      processFile(event) {
        this.file = event.target.files[0].name;
        this.base64 = event.target.files[0];
      },
      testeErro(){
        ErrorService.getMessage()
      },
      iniciar() {
        let file = document.getElementById("arquivo").files[0];
        if(!file){
          this.$swal({text:"Selecione um XML para iniciar o processo", 
            type: "warning",
          });
        }else{
          let data = new FormData();
          
          
          data.append('arquivo',file);

          FiscalService.CarregarCompra(data).then(ret => {
              if(ret.data.existe) {
                
              } else {
                
                if(ret != null && ret.data.NFe.infNFe != null){
                  let nfe = null;

                  nfe = ret.data.NFe.infNFe;
                  nfe.protNFe = {};
                  nfe.protNFe = ret.data.protNFe;

                  try {
                    let stores = JSON.parse(localStorage.getItem('stores'))
                    let idi = localStorage.getItem('current_idi')

                    const store = stores.find(x => x.idi == idi)

                    if(store && store.cnpj.replace(/\D/g,'') != nfe.dest.CNPJ) {
                      this.$swal({
                        text: 'Essa nota não esta destinada a sua empresa.',
                        type: "warning",
                        confirmButtonText:'Entendo'
                      }).then(data => {

                      });

                      return;
                    }

                    this.notaCarregada = true;
                    this.$refs.entradaComponent.setNota(nfe,file)

                  } catch(e) {
                    console.error(e)

                    this.notaCarregada = true;
                    this.$refs.entradaComponent.setNota(nfe,file)
                  }

                  
                } else {
                  this.$swal({
                    text: 'XML Inválido, tente novamente',
                    type: "warning",
                    confirmButtonText:'Entendo'
                  });
                }
              }
            }).catch(error =>{
              console.error(error)
              ErrorService.getMessage(error.response)

              // this.$swal({text:error.response.data,
              //   type: "warning",
              // });
            });
        }
      },
      loadNotas() {
        let params = `?data_inicio=${this.data_inicio}&data_fim=${this.data_fim}`

        FiscalService.loadNotasCompra(params).then(res => {
          this.notas = res.data;
        }).catch(err => {
            ErrorService.getMessage(err.response)

        })
        this.reloadNotasHref();
      },
      reloadNotasHref(){
        let stores = JSON.parse(localStorage.getItem('stores'));
        let loja = stores.find(element => element.idi == localStorage.getItem('current_idi'));
        let url = process.env.VUE_APP_API_URL + 'relatorioNotasCompra'
        let params = "?token=" + localStorage.getItem("token") + "&" + "data_fim=" +this.data_fim+"&data_inicio="+this.data_inicio+"&cnpj="+loja.cnpj+"&razao_social="+ encodeURIComponent(loja.razao_social);

        this.notasHref = url + params
      }
    },
    mounted() {
      let stores;
      try{
        stores = JSON.parse(localStorage.getItem('stores'));
        this.loja = stores.find(element => element.idi == localStorage.getItem('current_idi'));
      }catch(err){
        console.error(err);
      }
      this.loadNotas();
    }
}
</script>

<style scoped>
</style>